import React from 'react';

const Stats = ({
  totalHours,
  completed,
  tasks,
  gruntCount,
  balance,
  address
}) => {
  return (
    <article className="pa3 pa5-ns" data-name="slab-stat">
      <h1 data-test="projectTitle">
        {address === '0x98c92E6bD45e95032c7fd8b254a96D20839EfA50'
          ? 'The Local Food Project'
          : address === '0x6964A605360409829002d557F89A51c81AaEeD40'
            ? 'GruntFunder'
            : address}
      </h1>
      <dl className="dib mr5">
        <dd className="f6 f5-ns b ml0">Total Hours</dd>
        <dd className="f3 f2-ns b ml0">{totalHours}</dd>
      </dl>
      <dl className="dib mr5">
        <dd className="f6 f5-ns b ml0">Completed Tasks</dd>
        <dd className="f3 f2-ns b ml0">{completed}</dd>
      </dl>
      <dl className="dib mr5">
        <dd className="f6 f5-ns b ml0">Pending Approvals</dd>
        <dd className="f3 f2-ns b ml0">{tasks}</dd>
      </dl>
      <dl className="dib mr5">
        <dd className="f6 f5-ns b ml0">Grunts</dd>
        <dd className="f3 f2-ns b ml0">{gruntCount}</dd>
      </dl>
      <dl className="dib">
        <dd className="f6 f5-ns b ml0">Balance</dd>
        <dd className="f3 f2-ns b ml0">{balance} ETH</dd>
      </dl>
      <dl className="dib mr5">
        <dd className="f6 f5-ns b ml0">Project Link</dd>
        <dd className="f3 f2-ns b ml0">
          <small>
            <a href="">https://workflowy.com/s/C_Yv.YUjxnt5doU</a>
          </small>
        </dd>
      </dl>
    </article>
  );
};

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Stats.jsx